import { jsx as _jsx } from "react/jsx-runtime";
import { Table } from 'antd';
import { DownloadDocument } from '../../utils/commonUtil';
const RegulatoryLibraryTable = ({ data }) => {
    const columns = [
        {
            title: 'Document Title',
            dataIndex: 'strDocumentTitle',
            key: 'strDocumentTitle',
            width: 500
        },
        {
            title: 'Document',
            dataIndex: 'strDocName',
            key: 'strDocName',
            width: 500,
            render: (text, record) => record.strDocName ? (_jsx("a", { onClick: () => DownloadDocument(`${record === null || record === void 0 ? void 0 : record.strDocRefId}`), target: "_blank", rel: "noopener noreferrer", children: text })) : null
        }
    ];
    return (_jsx(Table, { columns: columns, dataSource: data, rowKey: "intUniqueId", pagination: { pageSize: 20 }, rowClassName: (record, index) => (index % 2 === 0 ? 'evenRow' : 'oddRow'), style: { width: '100%' }, size: 'small' }));
};
export default RegulatoryLibraryTable;
